import { Component, OnInit } from '@angular/core';
import { FullData } from 'src/app/shared/interfaces/interfaces';
import { environment } from 'src/environments/environment';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from 'src/app/store/store';
import { PepActions } from 'src/app/store/actions';
import { TagPage } from 'src/app/store/actions/ui.actions';

@Component({
  selector: 'pep-component',
  templateUrl: './pep.component.html',
  styleUrls: [
    '../../../global.scss', './../../bfpe-common/pep-form/pep-form.component.scss'
  ]
})
export class PepComponent implements OnInit {
  pepParams = { url: '/api/pep/', isClient: true };
  editing = 0;
  staticAssetsUrl = environment.staticScripts.staticAssets;
  displayForm = false;
  forms = [
    { title: 'Padres', subTitles: [{title: 'Padre', group: ['padre']}, {title: 'Madre', group: ['madre']}], expand: false, save: 'Guardar', hasValue: false, edit: false},
    { title: 'Cónyuge / Conviviente', expand: false, save: 'Guardar', group: 'conyuge', hasValue: false, edit: false},
    { title: 'Hijos', expand: false, save: 'Guardar y continuar', group: 'hijos', isArray: true, hasValue: false, edit: false},
    { title: 'Suegros', subTitles: [{title: 'Suegro', group: ['suegro']}, {title: 'Suegra', group: ['suegra']}], expand: false, save: 'Guardar', hasValue: false, edit: false},
    { title: 'Abuelos', subTitles: [{title: 'Abuelos Paternos', group: ['AbueloPaterno', 'AbuelaPaterno']},
    { title: 'Abuelos maternos', group: ['AbueloMaterno', 'AbuelaMaterno']}],
      expand: false, save: 'Guardar', hasValue: false, edit: false},
    { title: 'Hermanos', expand: false, save: 'Guardar y continuar', group: 'Hermanos', isArray: true, hasValue: false, edit: false },
    { title: 'Nuera / Yerno', expand: false, save: 'Guardar', group: 'yernoONuera', isArray: true, hasValue: false, edit: false},
    { title: 'Nietos', expand: false, save: 'Guardar y continuar', group: 'Nietos', isArray: true, hasValue: false, edit: false}
  ];

  capitalForm = {
    hasValue: false, edit: false
  };

  formData: FormGroup = this.formBuilder.group({
    position: ['', Validators.required],
    institution: ['', Validators.required],
    startDate: ['', Validators.required],
    customerJointEmail: [''],
    padre: this.formBuilder.group({nombre: '', apellidos: '', edad: ''}),
    madre: this.formBuilder.group({nombre: '', apellidos: '', edad: ''}),
    conyuge: this.formBuilder.group({nombre: '', apellidos: '', edad: ''}),
    hijos: this.formBuilder.array([
      this.formBuilder.group({nombre: '', apellidos: '', edad: ''})
    ]),
    suegro: this.formBuilder.group({nombre: '', apellidos: '', edad: ''}),
    suegra: this.formBuilder.group({nombre: '', apellidos: '', edad: ''}),
    yernoONuera: this.formBuilder.array([
      this.formBuilder.group({nombre: '', apellidos: '', edad: ''})
    ]),
    AbueloPaterno: this.formBuilder.group({nombre: '', apellidos: '', edad: ''}),
    AbuelaPaterno: this.formBuilder.group({nombre: '', apellidos: '', edad: ''}),
    AbueloMaterno: this.formBuilder.group({nombre: '', apellidos: '', edad: ''}),
    AbuelaMaterno: this.formBuilder.group({nombre: '', apellidos: '', edad: ''}),
    Nietos: this.formBuilder.array([
      this.formBuilder.group({nombre: '', apellidos: '', edad: ''})
    ]),
    Hermanos: this.formBuilder.array([
      this.formBuilder.group({nombre: '', apellidos: '', edad: ''})
    ]),
    capitalMayor25: false,
    capitales: this.formBuilder.array([
      this.formBuilder.group({RUC: '', RazonSocial: ''})
    ])
  });

  public data: FullData = {
    pepDefault: false,
    showPep: false,
    isPepActivate: null,
    experiencia: 'customer-info-update',
    content: {}
  };

  public hasError = {
    cargo: false,
    institucion: false,
    fechaInicio: false
  };

  constructor(
    private formBuilder: FormBuilder,
    private store: Store<OnboardingProductsStore.AppState>
  ) {
    this.pepParams = environment.pepParams;
  }

  ngOnInit() {
    this.store.dispatch(TagPage({text: 'agregardatos'}));
  }

  fillData() {
    const pepData: FullData = this.formData.value as FullData;
    const pepStatus = this.formData.valid;
    this.store.dispatch(PepActions.savePepData({ pepData, pepStatus }));
  }

  public onClickPepEmpresas() {
    if (!this.data.content.capitalMayor25) {
      this.data.content.capitales = [{}];
    }
  }

  expandIndex(index) {
    this.forms[index].expand = !this.forms[index].expand;
  }

  editIndex(index, group) {
    this.editing = group;
    this.forms[index].edit = true;
  }

  deleteIndex(index, formIndex, group) {
    const formGroup = (this.formData.controls[`${group}`] as FormArray);
    formGroup.removeAt(index);
    if (!formGroup.length) {
      this.forms[formIndex].hasValue = false;
      this.addForm(formIndex, group);
    }
  }

  saveData(index) {
    this.forms[index].hasValue = true;
    this.forms[index].edit = false;
    this.fillData();
  }

  addForm(index, group) {
    const formGroup = (this.formData.controls[`${group}`] as FormArray);
    const subjectarray = this.formBuilder.group({nombre: '', apellidos: '', edad: ''});
    formGroup.push(subjectarray);
    this.editIndex(index, formGroup.length - 1);
  }

  editCapital(group) {
    this.editing = group;
    this.capitalForm.edit = true;
  }

  deleteCapital(index) {
    const formGroup = (this.formData.controls['capitales'] as FormArray);
    formGroup.removeAt(index);
    if (!formGroup.length) {
      this.capitalForm.hasValue = false;
      this.addCapital();
    }
  }

  saveCapital() {
    this.capitalForm.hasValue = true;
    this.capitalForm.edit = false;
    this.fillData();
  }

  addCapital() {
    const formGroup = (this.formData.controls['capitales'] as FormArray);
    const subjectarray = this.formBuilder.group({RUC: '', RazonSocial: ''});
    formGroup.push(subjectarray);
    this.editCapital(formGroup.length - 1);
  }
}
